import { RESOURCE_TYPE } from 'constant';
import { ACTIONS_TYPES } from 'redux/local';

export const loadGraph = async () => new Promise((resolve) => {
  const path = `${process.env.PUBLIC_URL}/static/`;

  const script = document.createElement('script');
  script.src = `${path}graph/js/next.js`;
  script.id = 'graph-script';
  document.body.append(script);

  const link = document.createElement('link');
  link.href = `${path}graph/css/next.css`;
  link.id = 'graph-style';
  link.rel = 'stylesheet';
  document.body.append(link);

  let libsCount = 0;

  const loaded = () => {
    const { nx } = window;
    const loadIcon = ({
      name, url, width = 32, height = 32,
    }) => {
      nx.graphic.Icons.registerIcon(
        name,
        url,
        width,
        height,
      );
    };

    [
      {
        name: 'lan',
        url: 'https://dcd.ionos.com/latest/dcd/brandings/default/img/icons/item_lan-private.black.svg',
      },
      {
        name: 'hdd',
        url: 'https://dcd.ionos.com/latest/dcd/brandings/default/img/icons/item_ssd.black.svg',
      },
      {
        name: 'cloud',
        url: 'https://dcd.ionos.com/latest/dcd/brandings/default/img/icons/item_cloudaccess.black.svg',
      },
    ].forEach((icon) => loadIcon(icon));

    resolve(true);
  };

  script.onload = () => {
    libsCount++;
    if (libsCount === 2) {
      loaded();
    }
  };

  link.onload = () => {
    libsCount++;
    if (libsCount === 2) {
      loaded();
    }
  };
});

export const generateServerNodes = ({ serverItems }) => (
  serverItems.map(({
    id: objId,
    href,
    properties: { name, vmState },
  }, index) => ({
    id: index,
    objId,
    name,
    href,
    icon: 'server',
    type: RESOURCE_TYPE.SERVER,
    status: vmState,
    action: ACTIONS_TYPES.DATA_CENTER.GET_SERVER,
  }))
);

export const generateLanNodes = ({ lansItems, serverItems }) => (
  lansItems.map(({
    id: objId,
    href,
    properties: { name, public: isPublic },
  }, index) => ({
    id: serverItems.length + index,
    objId,
    name: name || `LAN ${objId}`,
    href,
    icon: isPublic ? 'cloud' : 'lan',
    type: 'lan',
    status: '',
    action: ACTIONS_TYPES.LAN.GET,
  }))
);

export const getServerId = (href) => href.match(/.+?servers\/(.+?)\/.+/)[1];

export const getNodeIdFromDom = (targetDom) => {
  const getId = (e) => e.getAttribute('data-id');
  const getParents = (e, depth = 1) => (
    depth === 1 ? e.parentNode : getParents(e.parentNode, --depth)
  );

  return getId(getParents(targetDom)) || getId(getParents(targetDom, 2));
};

export const addNodeStatus = ({ graphInstance }) => {
  const { nx } = window;
  graphInstance.eachNode((node) => {
    const model = node.model().get() || {};
    if (model.type !== RESOURCE_TYPE.SERVER) return false;
    const status = node.model().get('status');

    const dot = new nx.graphic.Circle({
      r: 3,
      cx: -15,
      cy: -10,
    });
    let color = '#f00';
    if (status === 'RUNNING') {
      color = '#0f0';
    }
    dot.set('fill', color);
    dot.attach(node);
    node.dot = dot;
    return true;
  }, nx.graphic.Topology.Layer);
};
